import { render } from "./mat-dialog.vue?vue&type=template&id=49ad7ed4&scoped=true&lang=true"
import script from "./mat-dialog.vue?vue&type=script&lang=js"
export * from "./mat-dialog.vue?vue&type=script&lang=js"

import "./mat-dialog.vue?vue&type=style&index=0&id=49ad7ed4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ad7ed4"]])

export default __exports__